export const USER_ID = 'livingmid'
export const PRODUCT_IMPRESSION = 'productImpression'
export const PRODUCT_IMPRESSION_CLICK = 'productImpressionClick'
export const PRODUCT_DETAIL = 'productDetail'
export const ADD_TO_CART = 'addToCart'
export const CHECKOUT = 'checkout'
export const PURCHASE = 'purchase'
export const ARTICLE_PAGEVIEW = 'living_article'
export const PRODUCT_INTRO = 'living_prodintro'
export const ALBUM_PAGEVIEW = 'photo_album'
export const ALBUM_DETAIL = 'photo_detail'
export const BANNER_CLICK = 'living_banner'
export const BANNER_IMPRESSION_UNIQUE = 'banner_unique_imp'
export const BANNER_IMPRESSION_REPEATED = 'banner_repeated_imp'
export const VENDER_PAGEVIEW = 'living_partner_view'

export const ASSESSED_PRICE = '0'
